import type { Observable } from 'rxjs';

import type { CandidateSelectOption } from '@core/search-types';

export abstract class CandidateSelectDropdownStrategy {
  public abstract candidates: Observable<CandidateSelectOption[]>;
  public abstract fetch(query: string, selectedLength: number): void;
}
